import Underline from '@tiptap/extension-underline';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';

interface ViewerProps {
  content: string;
  style?: 'default' | 'prose';
}

const Viewer = ({ content, style }: ViewerProps) => {
  const editor = useEditor({
    extensions: [StarterKit, Underline],
    content: content,
    editable: false,
    shouldRerenderOnTransaction: false,
    immediatelyRender: false,
  });

  if (!editor) return <></>;

  const className: string = style !== 'default' ? 'prose-mt-0 prose max-w-none dark:prose-invert' : '';

  return (
    <article className={className}>
      <EditorContent editor={editor} readOnly={true} />
    </article>
  );
};

export default Viewer;
